import * as React from "react";
import { cva } from "class-variance-authority";
import { cn } from "@/lib/utils";

const chipVariants = cva(
  "inline-flex items-center gap-1 rounded-full border px-2.5 py-1 text-xs font-medium",
  {
    variants: {
      tone: {
        neutral: "border-slate-200 bg-white text-slate-700",
        primary: "border-emerald-200 bg-emerald-50 text-emerald-700",
        warning: "border-amber-200 bg-amber-50 text-amber-700",
      },
    },
    defaultVariants: {
      tone: "neutral",
    },
  },
);

const Chip = React.forwardRef(({ className, tone, ...props }, ref) => (
  <span ref={ref} className={cn(chipVariants({ tone }), className)} {...props} />
));

Chip.displayName = "Chip";

export { Chip };
